import { ALL_REGION_SLUGS } from 'lib/region/regionLocale';
import { CartPolicy } from './types';
import { pass } from './cartLineHelpers';

function deriveCartSource(pagePath: string, isUpsell: boolean): string {
  if (isUpsell) return 'upsell';
  if (!pagePath) return '';
  const segments = pagePath.replace(/^\/|\/$/g, '').split('/');
  if (segments[0] && ALL_REGION_SLUGS.includes(segments[0])) segments.shift();
  return segments.join('_') || 'home';
}

export const cartSourcePolicy: CartPolicy = (input, _cart, meta) => {
  const lines = input.lineItemsToAdd;
  if (!lines?.length) return pass(input);

  const cartSource = deriveCartSource(meta.pagePath, meta.isUpsell);
  if (!cartSource) return pass(input);

  const next = lines.map((line) => {
    const attributes = line.attributes ?? [];
    if (attributes.some((a) => a.key === '_cart_source')) return line;
    return {
      ...line,
      attributes: [...attributes, { key: '_cart_source', value: cartSource }],
    };
  });

  return { input: { ...input, lineItemsToAdd: next }, reasons: [`cart source: ${cartSource}`] };
};
